<template>
    <v-toolbar dark flat color="#f57b42">
        <v-toolbar-title :style="$store.state.textFormatting.headers"> WARNING - {{daysleft}} days left to migrate (new dates) - click for info</v-toolbar-title>
        <info>
            <template slot>
                Removal of old style ASN and Prefix rules.
            </template>
            <template slot="body">
                <p>The 'ASN', 'Restricted Prefixes' and 'Alert Refinement' Rules are being replaced with 'Alert Rules'.</p>
                <p>The new Alert Rules are the initial stage for bringing in new alerting features that are not possible with the old style rules, so users need to move their existing settings to the new format before October 2023.</p>
                <p>There are two ways to acheive this:
                <ul>
                    <li> Re-create the rules by hand in the 'Alert Rules' settings</li>
                    <li> Export your old rules and import them again in the 'Alert Rules' settings</li> 
                </ul>
                Depending on how many you have, it may be easier to re-create them so that you can make best use of the new structure.</p>
                <p>After the 1st Feb, the old alerts will be disabled but still viewable in the website for reference</p>
                <p>After the 1st Mar, the old settings will be removed completely along with the menus that support them</p>
                <p>If you have any questions, please email <a :href="emaillink">{{emailname}}</a></p>
            </template>
        </info>
    </v-toolbar>
</template>
<script>
import info from '../../shared/operational/infopopout.vue';

export default {
    name: 'oldRules',
    components: {
        info,
    },
    data() {
        return {
            emaillink: 'mailto:bgpspotlight@bt.com',
            emailname: 'bgpspotlight@bt.com',
            daysleft: 0
        } 
    },
    beforeMount () {
        var countDownDate = new Date("Nov 1, 2023 09:00:00").getTime();
        var now = new Date().getTime();
        var distance = countDownDate - now;
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        this.daysleft=days
    }
}
</script>